import React from "react";
import { useUscSelector } from "../../../../../redux/store";
import { useUscLabel } from "../../../../../utils/labels";
import SectionLegal from "./sections/SectionLegal";
import Text from "../../../../../../shared-components/lexus/styles/atoms/Text";
import * as Styles from "./LegalSpecifications.styles";
import { enableLegalEcoLabel } from "../../../../../utils/pdpUtils";

const LegalSpecifications = (): JSX.Element | null => {
    const country = useUscSelector((state) => state.commonSettings.country);
    const uscContext = useUscSelector((state) => state.vehicle.type);
    const uscSettings = useUscSelector((state) => state.uscSettings);

    const title = useUscLabel("uscPdpEcolabelTitle");

    // TODO tracking

    // TDG SCL specific section (for now)
    if (!enableLegalEcoLabel(country, uscContext, uscSettings)) return null;

    return (
        <Styles.Wrapper>
            <Text tag="h2" variant="h4">
                {title}
            </Text>
            <SectionLegal />
        </Styles.Wrapper>
    );
};

export default LegalSpecifications;
